module.exports = __webpack_public_path__ + "media/images/updates-icon-a89f9c333d36c6d926d04f957395a7c2.svg";